var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoPacer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 21,
    fill: "#FFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 167,
    transform: "translate(-39 -44)",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -39,
    y: -44,
    width: 256,
    height: 2296,
    fill: "black",
    fillOpacity: 0.01
  })), /*#__PURE__*/React.createElement("rect", {
    x: -19,
    y: -17,
    width: 216,
    height: 56,
    rx: 12,
    fill: "#1F2128"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 2.05554L2.05554 8.38886L13.6666 14.7222L25.2777 8.38886L13.6666 2.05554ZM14.1648 14.5807C14.0139 14.6631 13.8503 14.7232 13.6666 14.7232C13.483 14.7232 13.3183 14.6631 13.1673 14.5807L13.161 14.5944L7.3333 11.9915V14.7232C7.3333 16.4712 10.7512 18.9454 13.6666 18.9454C16.5821 18.9454 19.9999 16.4712 19.9999 14.7232V11.9915L14.1722 14.5944L14.1648 14.5807Z",
    fill: "#1F2128",
    stroke: "#FFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.3333 8.38887C26.3333 7.98987 26.1021 7.65526 25.7759 7.47581L25.7833 7.46209L14.1722 1.12878L14.1649 1.1425C14.0139 1.05911 13.8503 1 13.6666 1C13.483 1 13.3183 1.05911 13.1674 1.1425L13.161 1.12878L1.54994 7.46209L1.55628 7.47581C1.23011 7.65526 1 7.98987 1 8.38887C1 8.78787 1.23011 9.12248 1.55628 9.30192L1.54994 9.31564L6.27776 11.8944V14.7232C6.27776 17.6387 9.58586 20.001 13.6666 20.001C17.7474 20.001 21.0555 17.6387 21.0555 14.7232V11.8944L25.7833 9.3167L25.7759 9.30298C26.1021 9.12353 26.3333 8.78787 26.3333 8.38887ZM18.9444 14.7222C18.9444 16.4702 16.5821 17.8888 13.6666 17.8888C10.7512 17.8888 8.38887 16.4702 8.38887 14.7222V13.046L13.161 15.649L13.1674 15.6352C13.3183 15.7176 13.483 15.7777 13.6666 15.7777C13.8503 15.7777 14.0139 15.7176 14.1649 15.6352L14.1722 15.649L18.9444 13.047V14.7222ZM13.6666 13.5199L4.25955 8.38992L13.6666 3.25783L23.0727 8.38887L13.6666 13.5199Z",
    fill: "#808191",
    stroke: "#FFF",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0446 17.5595L22.0572 17.5553L21.0555 14.5512V11.5555C21.0555 11.0056 20.6048 10.69 20.4665 10.6203L20.4718 10.6108L14.1385 7.44415L14.1332 7.45365C13.9917 7.38292 13.8366 7.33331 13.6666 7.33331C13.0829 7.33331 12.6111 7.80514 12.6111 8.38887C12.6111 9.16786 13.1948 9.33358 13.1948 9.33358L18.9444 12.2089V14.5522L17.9427 17.5563L17.9553 17.5606C17.9195 17.6651 17.8888 17.7717 17.8888 17.8888C17.8888 18.4715 18.3607 18.9444 18.9444 18.9444C18.9444 19.5281 19.4162 19.9999 20 19.9999C20.5826 19.9999 21.0555 19.5281 21.0555 18.9444C21.6382 18.9444 22.1111 18.4715 22.1111 17.8888C22.1111 17.7717 22.0794 17.6651 22.0446 17.5595Z",
    fill: "#808191",
    stroke: "#FFF",
    strokeWidth: 0.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_0_1",
    x: -39,
    y: -44,
    width: 256,
    height: 2296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.894118 0 0 0 0 0.894118 0 0 0 0 0.894118 0 0 0 0.100962 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 167,
    fill: "white",
    transform: "translate(-39 -44)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPacer);
export default __webpack_public_path__ + "static/media/ico-pacer.35f0d725.svg";
export { ForwardRef as ReactComponent };